<app-loader *ngIf="Loader"></app-loader>
<div class="min-w-screen min-h-screen login-bg flex items-center justify-center px-5 py-5 bg-center bg-cover">

  <!-- step 1 -->
  <div class="bg-white text-gray-500 rounded-3xl shadow-xl w-full overflow-hidden lg:w-7/12"
    *ngIf="login_tab && !resendVerify">
    <div class="md:flex w-full">

      <div class="w-full md:w-1/2 pt-10 md:pl-10">
        <div>
          <img src="images/surplustek-logo.png" routerLink="/" class="cursor-pointer w-48" />
        </div>

        <div class="p-5">
          <div class="font-semibold text-lg text-slate-600 mb-5">Login</div>

          <form #f="ngForm" name="form" autocomplete="off" (ngSubmit)="f.valid && LoginonSubmit(f)"
            class="my-5 w-full p-px">

            <div class="w-full mb-4">
              <input type="text" maxlength="150" name="emailOrMobileNumber" [(ngModel)]="form.emailOrMobileNumber"
                required Mobile Number format is wrong
                [ngClass]="{ 'error-border': (f.submitted || emailOrMobileNumber.touched) && emailOrMobileNumber.invalid }"
                class="w-full px-4 py-2 rounded-lg bg-neutral-100 text-sm border-none text-gray-600 focus:ring-1 focus:ring-gray-400 placeholder:text-gray-400"
                placeholder="Email or Mobile Number" #emailOrMobileNumber="ngModel">

              <div *ngIf="(f.submitted || emailOrMobileNumber.touched) && emailOrMobileNumber.invalid" class="">
                <div class="text-red-500 text-xs mt-1" *ngIf="emailOrMobileNumber.errors?.['required']">Email or Mobile
                  Number is required</div>
                <div class="text-red-500 text-xs mt-1" *ngIf="emailOrMobileNumber.errors?.['maxlength']">Must not exceed
                  150 characters</div>
              </div>
            </div>

            <div class="w-full mb-4">

              <div class="relative">
                <input type="{{ hidePassword ? 'password' : 'text' }}"
                  class="w-full px-4 py-2 rounded-lg bg-neutral-100 text-sm border-none text-gray-600 focus:ring-1 focus:ring-gray-400 placeholder:text-gray-400"
                  name="password" autocomplete="new-password" [(ngModel)]="form.password" required maxlength="25"
                  #password="ngModel" [ngClass]="{ 'error-border': f.submitted && password.errors }"
                  placeholder="Password" />

                <span (click)="togglePasswordVisibility()" class="absolute right-4 top-2 cursor-pointer">
                  <svg *ngIf="!hidePassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21">
                    </path>
                  </svg>
                  <svg *ngIf="hidePassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z">
                    </path>
                  </svg>
                </span>
              </div>


              @if (f.submitted && password.errors) {
              <div class="text-red-500">
                @if (password.errors['required']) {
                <div class="text-red-500 text-xs mt-1">Password is required</div>
                } @if (password.errors['maxlength']) {
                <div class="text-red-500 text-xs mt-1">Password must not exceed 25 characters</div>
                }
              </div>
              }
              
            </div>
            
            <button type="submit"
            class="block w-full mx-auto bg-orange-500 hover:bg-orange-600 text-white rounded-lg px-3 py-2 font-semibold focus:outline-none">
            Login</button>
          </form>
        </div>
      </div>
      <div class="hidden md:block w-1/2 p-5 m-auto items-center">
        <img src="images/4957412_Mobile-login 1.svg" class="m-auto" />
      </div>
    </div>

  </div>


</div>
